import React from "react";

// Rendered as the full-page "agent" section, the chat needs the centered shell the
// presentation layout expects. Everywhere else (modals, panels, portaled slots) the
// host already provides the box, so the conversation is returned bare.
const ChatView = ({ 
  conversationComponent, 
  isAgentSection = false 
}) => {

  if (!isAgentSection) 
    return conversationComponent;

  return (
    <div
      id="agent"
      className="w-100 h-100 d-flex justify-content-center align-items-center position-relative">
      <div className="w-100 h-100 overflow-auto d-flex" style={{ zIndex: "10" }}>
        <div id="agent-chat" className="position-relative h-100 flex-fill">
          <div className="h-100 m-auto">
            {conversationComponent}
          </div>
        </div>
      </div>
    </div>
  );

}

export default ChatView;